import { z } from 'zod';

export const IssueSeveritySchema = z.enum(['low', 'medium', 'high', 'unknown']);
export type IssueSeverity = z.infer<typeof IssueSeveritySchema>;

export const IssueStatusSchema = z.enum(['open', 'closed', 'not_a_bug']);
export type IssueStatus = z.infer<typeof IssueStatusSchema>;

export interface IssueCategorySummary {
  id: string;
  key: string;
  label: string;
  description: string | null;
  instructions: string | null;
}

export interface IssueCategorySetting extends IssueCategorySummary {
  isActive: boolean;
  isSystem: boolean;
  sortOrder: number;
}

export const IssueSourceKindSchema = z.enum([
  'crawler_analysis',
  'exploratory_attempt',
  'qa_page_test',
  'workflow_test',
  'chaos_test',
  'adhoc_test',
  // A human or agent filed this issue directly via `cofactor issue create`.
  'manual',
]);
export type IssueSourceKind = z.infer<typeof IssueSourceKindSchema>;
